import TextSimple from "@/src-refactor/modules/shared/components/typography/text-simple/TextSimple";
import styled from "@emotion/styled";
import React from "react";
interface SimpleCardProps {
  showBg: boolean;
  children: React.ReactNode;
  title?: string;
}
function SimpleCard2(props: SimpleCardProps) {
  return (
    <Content>
      {props.title && (
        <ContentLabel showBg={props.showBg}>
          <TextSimple
            color="blue-02"
            size="title"
            weight="bold"
            font="gotham"
          >
            {props.title}
          </TextSimple>
        </ContentLabel>
      )}
      <ContentChildren>{props.children}</ContentChildren>
    </Content>
  );
}

export default SimpleCard2;

const Content = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 1fr;
  grid-template-rows: 2.5em auto;
  margin: 0px 0;
  border-radius: 15px;
  overflow: hidden;
`;

const ContentLabel = styled.div<{ showBg: boolean }>`
  width: 100%;
  background-color: ${props =>
    props.showBg ? "var(--m-color-blue-01)" : "white"};
  display: flex;
  align-items: center;
  padding: 20px 25px;
`;

const ContentChildren = styled.div`
  gap: 1rem;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: white;
  padding: 20px 25px;
`;
